import { render, staticRenderFns } from "./DicomViewer.vue?vue&type=template&id=14c03738&scoped=true"
import script from "./DicomViewer.vue?vue&type=script&lang=js"
export * from "./DicomViewer.vue?vue&type=script&lang=js"
import style0 from "./DicomViewer.vue?vue&type=style&index=0&id=14c03738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c03738",
  null
  
)

export default component.exports